import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=8fb186a4&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=8fb186a4&scoped=true&lang=sass&"
import style1 from "./Index.vue?vue&type=style&index=1&id=8fb186a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb186a4",
  null
  
)

export default component.exports